export default __webpack_public_path__ + "static/media/blue-jade.4e43aadf.webp";